<script>
  /* Svelte */
  import { slide } from "svelte/transition";

  /* Stores */
  import storeGlobal from "../../stores/storeGlobal";

  /* Constants */
  import Anchors from "../../constants/links";

  /* Components */
  import Logo from "../Logo.svelte";
  import Search from "./Search.svelte";
  import Filter from "./Filter.svelte";

  /* Functions */
  const toggleNav = () => {
    storeGlobal.updateItem('showNav', !$storeGlobal.showNav)
  }

  const switchMode = () => {
    storeGlobal.updateItem('darkMode', !$storeGlobal.darkMode);
  }
</script>

<!-- Pageheader -->
<header class="fixed
               top-0
               z-10
               w-full
               bg-white
               text-silver
               border-b
               border-smoke
               dark:bg-steel
               dark:border-steel"
        role="banner">

  <!-- inner wrapper -->
  <div class="relative py-3 px-4 text-center">

    <!-- nav toggle  -->
    <button class="absolute left-0 inset-y-0 focus:outline-none mx-4"
            on:click={ toggleNav }>

      <!-- Change icon depending on open or closeed nav -->
      {#if $storeGlobal.showNav}
        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
             class="fill-current w-4 h-3 dark:text-smoke_xd">
          <path d="M8.884 8l6.933-6.933a.625.625 0 10-.884-.884L8 7.116
                   1.067.183a.625.625 0 10-.884.884L7.116 8 .183 14.933a.625.625
                   0 10.884.884L8 8.884l6.933 6.933a.623.623 0 00.884 0 .625.625
                   0 000-.884z"/>
        </svg>
      {:else}
        <svg viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg"
             class="fill-current w-4 h-4 dark:text-smoke_xd">
          <path d="M15.666 0H.333C.149 0 0 .26 0 .58s.149.581.333.581h15.333c.184 0
                   .334-.26.334-.58S15.85 0 15.666 0zM15.666 5.42H.333C.149 5.42 0
                   5.68 0 6s.149.58.333.58h15.333c.184 0
                   .334-.26.334-.58s-.15-.58-.334-.58zM15.666 10.838H.333c-.184
                   0-.333.26-.333.58S.149 12 .333 12h15.333c.184 0 .334-.26.334-.581
                   0-.32-.15-.58-.334-.58z"/>
        </svg>
      {/if}
    </button>

    <!-- identity -->
    <Logo />

    <button class="absolute right-0 inset-y-0 focus:outline-none mx-4" on:click={ switchMode }>
      {#if $storeGlobal.darkMode }
        <svg class="w-5 h-5 stroke-current text-yellow_d" fill="none" stroke-linecap="round"
             stroke-linejoin="round" stroke-width="2" viewBox="0 0 10.286 10.286"
             xmlns="http://www.w3.org/2000/svg">
          <circle cx="5.1286" cy="5.1571" r="2.1403" stroke-width=".85619"/>
          <g stroke-width=".85613">
            <path d="M5.1286.4484v.8561M5.1286 9.0097v.8561M1.7983 1.8268l.6078.6078M7.8511
                     7.8796l.6078.6078M.41992 5.1571H1.276M8.9812 5.1571h.8561M1.7983
                     8.4874l.6078-.6078M7.8511 2.4346l.6078-.6078"/>
          </g>
        </svg>
      {:else}
        <svg class="w-5 h-5 stroke-current text-steel" fill="none" stroke-linecap="round"
             stroke-linejoin="round" stroke-width="2" viewBox="0 0 10.286 10.286"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M9.7698 5.5665A4.643 4.643 0 114.7192.5159a3.6113 3.6113 0 005.0506 5.0506z"
                stroke-width="1.0318"/>
        </svg>
      {/if}
    </button>
  </div>

  <!-- navigation -->
  {#if $storeGlobal.showNav}
    <nav class="mt-2 mb-4" transition:slide>
      {#each Anchors as anchor }
        <a class="block
                  ml-6
                  py-2
                  px-4
                  border-l
                  border-smoke
                  text-silver
                  hover:text-slate
                  capitalize
                  dark:text-silver
                  dark-hover:text-teal
                  dark:border-silver"
           href="{ anchor.url }"
           on:click="{ toggleNav }">

          { anchor.text }

        </a>
      {/each}
    </nav>
  {/if}

  <!-- Searchbar -->
  <div class="py-2 border-t border-smoke dark:border-slate px-4">
    <Search />
  </div>

  <!-- Filters -->
  <Filter/>

</header>
